let FormControls = function (props) {
  let disabled = props.enabled === false;
  let labels = props.labels || {};

  return (
    <div className="mc-form-controls">
      <button className="mc-button mc-save" onClick={props.onSave} disabled={disabled}>
        {labels.save || tx("save")}
      </button>
      <button className="mc-button mc-cancel" onClick={props.onCancel}>
        {labels.cancel || tx("cancel")}
      </button>
      {props.onDelete && (
        <button className="mc-button mc-delete" onClick={props.onDelete}>
          {labels.delete || tx("delete")}
        </button>
      )}
    </div>
  );
};

module.exports = FormControls;
